import Vue from 'vue';
import VueResource from 'vue-resource';
import { VueHammer } from 'vue2-hammer';
import 'ie-array-find-polyfill';

import ProduktZufallsgenerator from './ProduktZufallsgenerator.vue';

const mergeWith = require('lodash.mergewith');

Vue.config.productionTip = false

VueHammer.config.swipe = {
  direction: 6,
};

Vue.use(VueHammer);
Vue.use(VueResource);

export function init(optionen = {}) {
    const defaults = {
        rootElement: '#produkt-zufallsgenerator-app',
        request: {
            url: window.location.protocol + '//' + window.location.hostname,
            parameter: {
                'F': 'zufallsprodukte_ajax',
                'ANZAHL': 50,
            },
            limitNaechsteAnforderung: 10,
        },
        i18n: {
            startHeadline: 'Finde was du nie gesucht hast:',
            startButtontext: 'Button drücken und von Produkten überraschen lassen, die Sie nie gesucht hätten.',
            linktextZumProdukt: 'Zum Produkt',
            requestFehlermeldung: 'Produkte konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.'
        },
        hintergrund: {
            inaktiv: 'https://img.proidee.de/uimg/teaser/zufallsgenerator_bg_1920x530.jpg',
            aktiv: 'https://img.proidee.de/uimg/teaser/zufallsgenerator_blur_bg.jpg',
        },
        responsive: {
            breakpointDesktop: 992,
        },
        imgLazyLoad: true,
        herkunftIntern: 'HI=cs_zufallsgenerator',
        paramKommeVon: 'KOMME_VON=cs_zufallsgenerator',
    };
    optionen = mergeWith(
            defaults,
            optionen,
            (def, opt) => opt === '' ? def : undefined
        );

    new Vue({
        optionen,
        render: h => h(ProduktZufallsgenerator, {
            props: {
                optionen
            }
        }),
    }).$mount(optionen.rootElement);
}

